import  { useEffect } from 'react';
import { Footer } from '../../components/footer';
import { useParams } from 'react-router-dom';
import { useUserVerifyMail } from '../profile-details/api/profileapi';
import { useToast } from '../../hook/usetoast';


const Dashboard = () => {
    const toast =useToast()

    const { id } = useParams()

    useEffect(() => {
        verifyMail()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    const verfiyMail = useUserVerifyMail()
    const verifyMail = async () => {
        try {
            const res = await verfiyMail.mutateAsync({ id: id })
            
            if(res?.status){
                toast.success(res.message)
            }else{
                toast.error(res.message)

            }

        } catch (error) {

        }
    }

 

    return (
        <>
        <div className="mainContent">
            <div className="pageContent def-py-30">
                <div className='container'>
                    <div className="appPagetitle">Dashboard</div>
                    <div className='row'>
                    
                    </div>
                </div>
            </div>
        </div>
        <Footer />        
        </>
    )
}

export default Dashboard;